import { axiosInstance, getUrl } from './req';
import {
    login,
    signup,
    k9Register,
    resetPassword,
    resendVerificationEmail,
    setNewPassword,
    verifyEmail,
    twoFactorAuthInit,
    twoFactorAuthVerify,
    twoFactorAuthUnlink,
    updatePassword,
    updateEmail,
    generateClientAPIKey,
    fetchClientAPIKey,
    removeClientAPIKey,
    updateClientAPIKey,
} from './account-api';
import { loadCurrentUser, loadUsers, loadUser, updateUser, deleteUser } from './users-api';
import { getDeviceFirmwareUpdate, updateDeviceFirmware } from './firmwares-api';
import {
    getHistoryForMap,
    getDeviceHistory,
    exportHistoryCsv,
    clearDeviceHistory,
    getDevicesHistory,
} from './history-api';
import {
    getDeviceGroupById,
    getDeviceGroups,
    createDeviceGroup,
    deleteDeviceGroup,
    updateDeviceGroupById,
} from './device-groups-api';
import {
    loadDevice,
    loadDevices,
    updateDevice,
    deleteShare,
    loadShare,
    createShare,
    updateShare,
    resendShare,
    removeAllShareOfDevice,
    removeDevice,
    locateDevice,
    updateDeviceAlarm,
    stopLiveTracking,
    addNotifyEmail,
    removeNotifyEmail,
    getModemInfo,
    updateOperatingMode,
    updateAirplaneMode,
    updateDeviceAlerts,
    updateGeoFence,
    createGeoFenceRoles,
    deleteGeoFence,
    transferDevice,
} from './devices-api';
import {
    loadResolvedPlans,
    subscribeUser,
    k9SubscribeUser,
    loadUserCurrentSubscriptions,
    loadUserSubscriptions,
    pauseSubscription,
    resumeSubscription,
    cancelSubscription,
    validateCoupon,
    createPaymentIntent
} from './subscriptions-api';
import { loadPlansByTypes } from './pricing-plans-api';
import { joinGroupByCode } from './pricing-groups-api';
import {
    getPaymentUser,
    attachPaymentMethodToCustomer,
    changePaymentMethod,
    removePaymentMethod,
    getPaymentHistory,
    getInvoiceDetails,
} from './stripe-payment';
import { getClientIP } from './ipAddress-api';
import { createGeoFence, getDeviceGeoFence } from './geo-fence-api';
import { deleteInviteUser, inviteUser, loadShareUser } from './share-account';

export function setAuthToken(token: string | null) {
    // console.log(`API setAuthToken ${token}`);
    axiosInstance.defaults.headers.common['Authorization'] = token || '';
}

export default {
    axiosInstance,
    getUrl,

    setAuthToken,

    login,
    signup,
    k9Register,
    resetPassword,
    resendVerificationEmail,
    setNewPassword,
    verifyEmail,
    twoFactorAuthInit,
    twoFactorAuthVerify,
    twoFactorAuthUnlink,
    updatePassword,
    updateEmail,
    generateClientAPIKey,
    fetchClientAPIKey,
    removeClientAPIKey,
    updateClientAPIKey,

    loadCurrentUser,
    loadUsers,
    loadUser,
    updateUser,
    deleteUser,

    getHistoryForMap,
    getDeviceHistory,
    exportHistoryCsv,
    clearDeviceHistory,
    getDevicesHistory,
    loadDevice,
    loadDevices,
    updateDevice,
    updateDeviceAlerts,
    loadShare,
    deleteShare,
    createShare,
    updateShare,
    resendShare,
    removeAllShareOfDevice,
    removeDevice,
    locateDevice,
    updateDeviceAlarm,
    getDeviceFirmwareUpdate,
    updateDeviceFirmware,
    stopLiveTracking,
    addNotifyEmail,
    removeNotifyEmail,
    getModemInfo,
    updateOperatingMode,
    updateAirplaneMode,

    loadResolvedPlans,
    subscribeUser,
    k9SubscribeUser,
    pauseSubscription,
    resumeSubscription,
    cancelSubscription,
    loadUserCurrentSubscriptions,
    loadUserSubscriptions,
    createPaymentIntent,
    validateCoupon,

    loadPlansByTypes,

    getPaymentUser,
    attachPaymentMethodToCustomer,
    changePaymentMethod,
    removePaymentMethod,
    getPaymentHistory,
    getInvoiceDetails,
    getClientIP,

    joinGroupByCode,
    updateGeoFence,
    createGeoFenceRoles,
    deleteGeoFence,
    createGeoFence,
    getDeviceGeoFence,
    transferDevice,
    loadShareUser,
    inviteUser,
    deleteInviteUser,

    getDeviceGroupById,
    getDeviceGroups,
    createDeviceGroup,
    deleteDeviceGroup,
    updateDeviceGroupById,
};
